import Notify from "./shared/notify";

export default class Project {
  changeStatus(element, projectId, status) {
    projectId = projectId || $(element).attr('project_id') || $(element).data('project-id')
    status = status || $(element).val() || $(element).attr('data-status')

    if (!projectId || !status) return
    if ($(element).hasClass('active')) return

    const shouldSkipConfirm = $(element).closest('.modal-status-project').length > 0 ||
      $(element).data('skipStatusConfirm') === true ||
      $(element).attr('data-skip-status-confirm') === 'true'

    $('.modal-status-project.show').modal('hide')

    if (shouldSkipConfirm) {
      this._requestChangeStatus(projectId, status)
      $(`#modalStatus-${projectId}`).find('.status_popup_sp').find('li').removeClass('active')
      return
    }

    Popup.confirm('', {
      description: `プロジェクトのStatusを変更します。<br/>よろしいですか？`,
      success: () => {
        this._requestChangeStatus(projectId, status)
        $(`#modalStatus-${projectId}`).find('.status_popup_sp').find('li').removeClass('active')
      },
      cancel: () => {}
    })
  }

  showSearchProject() {
    if (!window.gon || !gon.project_feature) return

    if (gon.project_feature.is_search) {
      $('body').find('.show-hide-search-project').trigger('click');
    } else {
      $('body').find('.show-hide-search-project').prop('checked', false)
    }
  }

  openPopupUpdateNotifyStatus(project_id, project_name, current_status, bypass_confirm) {
    $('#offNoticeStatus').find('.submit-update-status').attr('data-project-id', project_id)
    $('#onNoticeStatus').find('.submit-update-status').attr('data-project-id', project_id)
    $('#offNoticeStatus').find('.submit-update-status').attr('data-project-name', project_name)
    $('#onNoticeStatus').find('.submit-update-status').attr('data-project-name', project_name)
    const bypass_after_setting = $('#tbody-list-project').attr('data-show-confirm-again')
    if((bypass_confirm == 'false' || bypass_confirm == '') && bypass_after_setting == 'false') {
      if(current_status) {
        $('#offNoticeStatus').modal('show')
      } else {
        $('#onNoticeStatus').modal('show')
      }
    } else {
      this.updateNotifyStatus($('#offNoticeStatus').find('.submit-update-status'), !current_status)
    }
  }

  updateNotifyStatus(element, status) {
    let project_id = $(element).attr('data-project-id');
    let project_name = $(element).attr('data-project-name');
    let url = Routes.update_notify_status_owner_project_path(project_id)
    Shared.callAjax(url, {status: status}, 'json', 'patch').done(function(data) {
      if(data.status) {
        $('#onNoticeStatus').modal('hide')
        $(`#status-${project_id} .accept-notify`).removeClass("d-none")
        $(`#status-${project_id} .reject-notify`).addClass("d-none")
        Popup.alert(`「${project_name}」プロジェクトの通知設定がONになりました。`)
      } else {
        $('#offNoticeStatus').modal('hide')
        $(`#status-${project_id} .accept-notify`).addClass("d-none")
        $(`#status-${project_id} .reject-notify`).removeClass("d-none")
        Popup.alert(`「${project_name}」プロジェクトの通知設定がOFFになりました。`)
      }
    })
  }

  _requestChangeStatus(projectId, status) {
    let project = { id: projectId, status }
    $.ajax({
      method: 'POST',
      url: Routes.owner_project_update_status_path(),
      dataType: 'json',
      data: { project },
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
      }
    }).done((data) => {
      if (data['error'] !== undefined) {
        Notify.error(data['error'])
      } else {
        $('#show_project_status').text(data.project.status)
        $(`.td-status-${projectId}`).html(data.status_html)
        $(`#modalSelectStatus-${projectId}`).find('li').removeClass('active')
        $(`#modalSelectStatus-${projectId}`).find(`li[data-status='${status}']`).addClass('active')

        const statusElement = $(".thumbnail-project-sp").is(":visible") ? $(`.thumbnail-project-sp #status-project-${projectId}`) : $(`#status-project-${projectId}`)
        const status_old = statusElement.attr('data-status-old')
        $(`#modalSelectStatus-${projectId}`).find(`li[data-status='${status_old}']`).find(`.current-status-text`).empty();
        $(`#modalSelectStatus-${projectId}`).find(`li[data-status='${status}']`).find(`.current-status-text`).append("（現在のステータス）")

        statusElement.attr('data-status-old', status)
        const old_status_class = this.fetchStatusStyle(status_old)
        const new_status_class = this.fetchStatusStyle(status)
        statusElement.removeClass(old_status_class)
        statusElement.addClass(new_status_class)
        Popup.alert('ステータスは変更されました。')
      }
    }).fail((_) => Notify.error('エラーが発生しました。もう一度確認してください'))
  }

  fetchStatusStyle(status_task) {
    let status_style = ''
    switch(status_task) {
      case '準備中':
          status_style = 'status_green_point'
          break;
      case '作業中':
          status_style = 'status_orange_point'
          break;
      case '完成':
          status_style = 'status_red_point'
          break;
      default:
          status_style = 'status_gray_point'
      break;
    }
    return status_style
  }

  updateSelectDisplayList(selectValue) {
    const url = Routes.update_display_type_project_owner_projects_path()
    Shared.callAjax(url, { select_value: selectValue}, '', 'post').done((data) => {
      location.reload()
    }).fail((data) => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  setModalBackParent(modalSelector, parentModalId) {
    const modal = $(modalSelector)
    if (!modal.length) return

    if (parentModalId) {
      modal.attr('data-tm-parent-modal-id', parentModalId)
    } else {
      modal.removeAttr('data-tm-parent-modal-id')
    }
  }

  openSettingAuthorityModal(resetValues = false, fromAuthority = false) {
    if (resetValues) {
      if ($('#js_select_company_type_task').length > 0) {
        $('#js_select_company_type_task').val('');
        $('#js_select_company_invites_task').empty();
        $('#js-select_users_invites').empty();
        $('#button_add_new_by_email').addClass('d-none')
        $('#button_add_member_of_partner').addClass('d-none')
        $('#button_add_new_member').addClass('d-none')
        $('#select_company_by_type').removeClass('d-none')
        $('#select_current_company').addClass('d-none')
      } else {
        $('#js_select_company_invites_task').val('');
        $('#js-select_users_invites').empty();

        if($('#current_company_id').length > 0) {
          this.getUserWithCompany('#current_company_id');
          $('#button_add_new_member').removeClass('d-none')
        } else {
          $('#button_add_member_of_partner').addClass('d-none')
        }
      }
      $('#add_new_email_permission').val('');
      $('#add_new_email_permission_type').val('')
    }
    Shared.appendSelect2('#addPermissionProjectAuthor', '#js_select_company_invites_task', 'アカウント名を選択してください', 'アカウント名を検索', null, InviteUserShare.removeCompanyPrefixSuffix)
    Shared.appendSelect2('#addPermissionProjectAuthor', '#js_select_company_type_task', '取引種類を選択してください', '', InviteUserShare.customOptionCompanyType, InviteUserShare.removeCompanyPrefixSuffix)
    Shared.appendSelect2('#addPermissionProjectAuthor', '#js-select_users_invites', 'メンバー名を選択してください', 'メンバー名を検索', null)
    this.setModalBackParent('#addPermissionProjectAuthor', 'popupInviteMember')
    this.closePopupInviteMember()
    $('#addPermissionProjectAuthor').find('#js_select_company_invites_task')
      .val($('#addPermissionProjectAuthor').find('#js_select_company_invites_task option[data-type="owners"]').val())
      .trigger('change')
    $("#addPermissionProjectAuthor").modal("show")

    if (fromAuthority) {
      $('.back-link-invite-wrapper').addClass('d-none')
    }
  }

  searchMemberByName(searchIcon, parentElement = '#popupInviteMember') {
    const modalEle = searchIcon.closest(`div${parentElement}`);
    const perPageSelection = modalEle.querySelector('.table-toolbar-member-add .show-number-of-page-js');
    const keyword = modalEle.querySelector('#searchInput').value.trim().toLowerCase();
    const rows = modalEle.querySelectorAll('tr.show_permission_tr');

    rows.forEach((row) => {
      const cells = row.querySelectorAll('td')
      const nameCell = cells[1]
      const rawText = nameCell ? nameCell.innerText : ''
      const nameText = rawText.toLowerCase().trim()
      const isMatched = nameText.includes(keyword.toLowerCase())

      if (isMatched || keyword === '') {
        row.setAttribute('is-showed', 'true');
      } else {
        row.setAttribute('is-showed', 'false');
      }
    })

    const perPage = Number(perPageSelection.textContent.trim())
    this.changeNumberPage(perPageSelection, null, perPage, parentElement);
  }

  async deleteProject(projectId, projectName, deleteAtProjectsList = true) {
    Popup.confirm(`<div class="delete-project-modal"><div class="modal-title">「${projectName}」プロジェクトを削除します。</div><div class="modal-body"><p>プロジェクトを削除すると、プロジェクト内の全てのデータが削除され復元できません。</p><p>「${projectName}」プロジェクトを削除してよろしいですか？</p></div></div>`, {
      success: () => { deleteProject(projectId, deleteAtProjectsList) },
      cancel: () => {},
      showCancelBtnOveride: true,
      confirmText: '削除する',
      cancelText: 'キャンセル',
    })
  }

  newProjectWithMaxQuantity(isCreate, isAkapon) {
    if (isCreate === 'true') return

    event.preventDefault();
    if (isAkapon) {
      $( "#errorModalForProject" ).modal('show');
    } else {
      Popup.alert(I18n.t('projects.cannot_create_with_plan'))
    }
  }

  addUserInvite(element) {
    const types = { owners: '自社', suppliers: '仕入先', clients: '販売先', collaborators: '外部' };
    const inviteUser = $('#js-select_users_invites').val();
    const inviteType = InviteUserShare.getCompanyType(element);
    const userName = $('#js-select_users_invites option:selected').text();
    const companyId = $('#js_select_company_invites_task :selected').val();
    const companyName = $(element).parent().find("#js_select_company_invites_task option:selected").text();

    if(inviteUser){
      const existingCheckbox = $("#popupInviteMember")
        .find(`.permission-row input.check-box-check-member[data-user-id="${inviteUser}"]`)
        .first();

      if(existingCheckbox.length) {
        const wasChecked = existingCheckbox.is(':checked');
        existingCheckbox.prop("checked", true);

        if (!wasChecked) {
          existingCheckbox.trigger("change");
        }
      } else {
        var elementAdd = this.permissionRow(inviteUser, userName, companyName, inviteType);
        $("#popupInviteMember").find(".permission-row").append(elementAdd);
        this.showEleFilterNewAdd();
      }

      const showMemberAddEle = document.querySelector('#popupInviteMember .show-number-member-add');
      if (showMemberAddEle && showMemberAddEle.getAttribute('is-show') === 'true') {
        const perPageSelection = document.querySelector('#popupInviteMember .table-toolbar-member-add .show-number-of-page-js');
        if (perPageSelection) this.changeNumberPage(perPageSelection);
      }

      $('#popupInviteMember').find('#element-is-change').val('true')
      $('#popupInviteMember').removeClass('d-none')
      $("#addPermissionProjectAuthor").modal("hide")
      $('#js-select_users_invites').find(`option[value="${inviteUser}"]`).remove();
      $('#invite-table-notice-text').empty();
      event.stopPropagation();
    }
  }

  openModalInviteByEmail(ele, isPlanFreeOrLight, planName, isNewCompany = false) {
    let companyType = InviteUserShare.getCompanyType();
    if (isNewCompany === 'true') {
      companyType = 'collaborators'
    }
    InviteUserShare.updateCompanyTypeText(companyType)
    if(companyType === 'collaborators' && isPlanFreeOrLight === 'true') {
      $('#modalShowRequestUpgradePlan').modal('show')
      return
    }
    this.setModalBackParent('#inviteByEmail', 'addPermissionProjectAuthor')
    $('#addPermissionProjectAuthor').modal('hide')
    $("#inviteByEmail").modal('show')
    $("#addPermissionProjectAuthor").modal('hide')
    $('#inviteByEmail').find('#permission_email').val('')
    $('.invite_email_error').html("")
    if (!!companyType) {
      const permissionType = companyType.slice(0, -1);
      let textCompanyType = ''
      if (companyType === 'collaborators') {
        textCompanyType = '新しい外部アカウントを招待する'
      } else if (companyType === 'clients') {
        textCompanyType = '新しい販売先アカウントを招待する'
      } else if (companyType === 'suppliers') {
        textCompanyType = '新しい仕入先アカウントを招待する'
      } else {
        textCompanyType = '新しいチームメンバーを招待します'
      }
      $('#inviteByEmail').find('#show-text-invite-by-type-company').text(textCompanyType);
      $('#inviteExistUserByEmail').find('#permission_type').val(permissionType)
      $('.add_new_email_permission_type#add_new_email_permission_type').val(permissionType)
      $('#add_new_email_permission_type').addClass('d-none');
      $('#permission_type_label').addClass('d-none');
    }
  }

  openModalInviteMemberOfPartner(isPlanFreeOrLight, planName, nameCompany) {
    const companyType = InviteUserShare.getCompanyType();
    InviteUserShare.updateCompanyTypeText(companyType)
    if(companyType === 'collaborators' && isPlanFreeOrLight === 'true') {
      $('#modalShowRequestUpgradePlan').modal('show')
      return
    }
    const companyName = $('#addPermissionProjectAuthor').find('#js_select_company_invites_task option:selected').text();
    let result = companyName.match(/・([^（(]+)\s*[（(]/)?.[1];
    if (['', null, undefined].includes(result)) result = nameCompany;

    $('.invite_email_error').html("")
    this.setModalBackParent('#inviteExistUserByEmail', 'addPermissionProjectAuthor')
    $("#addPermissionProjectAuthor").modal('hide')
    $("#inviteExistUserByEmail").modal('show')
    $("#inviteExistUserByEmail").find('#show-name-company-when-invite').text(result + '　');
    $("#inviteExistUserByEmail").find('#permission_name').val('')
    $("#inviteExistUserByEmail").find('#permission_email').val('')
  }

  handleCheckToAddPermission(element, userID){
    $('#popupInviteMember').find('#element-is-change').val('true')
    if($(element).is(":checked")) {
      if ($(element).parents('.checkbox_noborder_intable').hasClass('c-red-check')) {
        $(element).parents('.show_permission_tr').attr('is-new-add', 'true')
        this.showEleFilterNewAdd()
      }
      $(element).parent().parent().parent().find('.label-checkbox').removeClass("disabled")
    } else {
      if ($(element).parents('.checkbox_noborder_intable').hasClass('c-red-check')) {
        $(element).parents('.show_permission_tr').removeAttr('is-new-add')
        this.showEleFilterNewAdd(false)
      }
      $(element).parent().parent().parent().find('.label-checkbox').addClass('disabled')
    }

    const dataUserDelete = $(".list-user-delete");
    if(dataUserDelete.length > 0) {
      if($(element).is(":checked")) {
        $(".list-user-delete").val(dataUserDelete.val().replace(`${userID},`, ''));
      } else {
        $(".list-user-delete").val(`${dataUserDelete.val()}${userID},`)
      }
    }
  }

  handelCheckPermission(element, userID, userName) {
    Popup.confirm(
    `${userName}さんを招待解除すると、
      このプロジェクトに参加できなくなります。
      解除してよろしいですか？`, {
      success: () => {
        const dataUserDelete = $(".list-user-delete").val();
        $(".list-user-delete").val(`${dataUserDelete}${userID},`)
        if($("#assignAkairePopup").length > 0) {
          this.showEleFilterNewAdd(false)
        }
        $(`tr.tr-${userID}`).remove()
      },
      cancel: () => {},
      confirmText: '解除する',
      cancelText: '後で行う'
    })
  }

  handelCheckRequest(element, requestId, userName) {
    Popup.confirm(
    `${userName}さんを招待解除すると、
      このプロジェクトに参加できなくなります。
      解除してよろしいですか？`, {
      success: () => {
        const dataRequestDelete = $(".list-request-delete").val();
        $(".list-request-delete").val(`${dataRequestDelete}${requestId},`)
        $(`tr.tr-request-${requestId}`).remove()
      },
      cancel: () => {},
      confirmText: '解除する',
      cancelText: '後で行う'
    })
  }

  removeNewAddWaiting(element, user_email) {
    const self = this;
    Popup.confirm(
      `<div>${user_email}さんを招待解除すると、
      このプロジェクトに参加できなくなります。
      解除してよろしいですか？</div>`,
      {
        success: () => {
          $(element).closest('tr.show_permission_tr').remove();
          self.showEleFilterNewAdd(false);
        },
        cancel: () => {},
        confirmText: '解除する',
        cancelText: '後で行う',
        width: 'auto'
      }
    )
  }

  showListNewAdd(ele, parentElement = '#popupInviteMember') {
    const modalEle = ele.closest(`div${parentElement}`);
    const perPageSelection = modalEle.querySelector('.table-toolbar-member-add .show-number-of-page-js');
    if ($(ele).attr('is-show') && $(ele).attr('is-show') === 'true') {
      $(ele).attr('is-show', 'false')
      const text = window.innerWidth <= 576 ? '名' : $(ele).data('text')
      const number = $(ele).attr('data-number')
      $(ele).text(`${number} ${text}`)
    } else {
      const textHide = window.innerWidth <= 576 ? '戻る' : $(ele).data('text-hide')
      $(ele).attr('is-show', 'true')
      $(ele).text(textHide)
    }

    const perPage = Number(perPageSelection.textContent.trim())
    this.changeNumberPage(perPageSelection, null, perPage, parentElement);
  }

  async submmitListMember(ele) {
    const form = $(ele).parents('form')
    await Shared.reDrawDataTable()
    form.find('#submit-update-project-permissions').trigger('click')
  }

  showEleFilterNewAdd(isPositive = true) {
    const spanShow = $('#popupInviteMember').find('.show-number-member-add')
    const number = isPositive ? Number(spanShow.attr('data-number')) + 1 : Number(spanShow.attr('data-number')) - 1
    spanShow.attr('data-number', number)
    $('#popupInviteMember').find('.number-member-invite').val(number)
    if (spanShow.attr('is-show') === 'false') {
      const text = window.innerWidth <= 576 ? '名' : spanShow.data('text')
      spanShow.text(`${number}${text}`)
    } else {
      const textHide = window.innerWidth <= 576 ? '戻る' : spanShow.attr('data-text-hide')
      spanShow.text(textHide)
    }
    number === 0 ? spanShow.addClass('d-none') : spanShow.removeClass('d-none')
  }

  changeEachPageNew(ele, idModal ,numberItem) {
    const modal = $(ele).parents('.popup-invite-member')
    $(idModal).find('.option').removeClass('slted')
    $(idModal).find(`div[data-page="${numberItem}"]`).addClass('slted')
    $(idModal).find('.show-number-of-page-js').text(numberItem)
    $('#popupInviteMember').find('.show-number-of-page-js').text(numberItem)
    $(idModal).modal('hide')
    modal.find('.dt-length').find('.dt-input').val(numberItem).trigger('change');
  }

  permissionRow(userId, userName, companyName, type) {
    const types = { owners: '自社メンバー', suppliers: '仕入先メンバー', clients: '販売先メンバー', collaborators: '外部メンバー' }
    return `<tr class="show_permission_tr show_permission_tr_list" is-showed="true" is-new-add="true">
      <td>
        <label class="checkbox_noborder_intable c-red-check">
          <input type="checkbox" data-user-id="${userId}" value="collaborator" name="permission[${userId}]" checked="">
          <span class="checkbox_text"></span>
        </label>
      </td>
      <td class="py-1 px-1 px-xx-2 text-center d-none">${types[type]}</td>
      <td class="py-1 px-1 px-xx-2 text-ellipsis d-none">${companyName}</td>
      <td class="py-1 px-1 px-xx-2 text-ellipsis">
        <span id="profileImage" class="avatar-member">
          ${userName.charAt(0)}
        </span>
        ${userName}
      </td>
      <td class="d-none"><label class="checkbox_noborder_intable">
        <input name="user_permissions[${userId}[roles[project[super]]]]" type="hidden" value="false"><input id="permission_${userId}_project_supper" class="mr-2 scale-2 user_permission_checbox" type="checkbox" value="true" name="user_permissions[${userId}[roles[project[super]]]]">
        <span class="checkbox_text"></span>
      </label></td>
      <td class="d-none"><label class="checkbox_noborder_intable">
        <input name="user_permissions[${userId}[roles[task[create]]]]" type="hidden" value="false"><input id="permission_${userId}_task_create" class="mr-2 scale-2 user_permission_checbox" type="checkbox" value="true" checked="checked" name="user_permissions[${userId}[roles[task[create]]]]">
        <span class="checkbox_text"></span>
      </label></td>
      <td class="d-none"><label class="checkbox_noborder_intable">
        <input name="user_permissions[${userId}[roles[chat[admin_project]]]]" type="hidden" value="false"><input id="permission_${userId}_chat_admin_project" class="mr-2 scale-2 user_permission_checbox" type="checkbox" value="true" name="user_permissions[${userId}[roles[chat[admin_project]]]]">
        <span class="checkbox_text"></span>
      </label></td>
      <td class="d-none"><label class="checkbox_noborder_intable">
        <input name="user_permissions[${userId}[roles[chat[group_project]]]]" type="hidden" value="false"><input id="permission_${userId}_chat_group_project" class="mr-2 scale-2 user_permission_checbox" type="checkbox" value="true" name="user_permissions[${userId}[roles[chat[group_project]]]]">
        <span class="checkbox_text"></span>
      </label></td>
      <td class="d-none"><label class="checkbox_noborder_intable">
        <input name="user_permissions[${userId}[roles[chat[task]]]]" type="hidden" value="false"><input id="permission_${userId}_chat_task" class="mr-2 scale-2 user_permission_checbox" type="checkbox" value="true" checked="checked" name="user_permissions[${userId}[roles[chat[task]]]]">
        <span class="checkbox_text"></span>
      </label></td>
      <td class="d-none"><label class="checkbox_noborder_intable">
        <input name="user_permissions[${userId}[roles[chat[ticket]]]]" type="hidden" value="false"><input id="permission_${userId}_chat_ticket" class="mr-2 scale-2 user_permission_checbox" type="checkbox" value="true" name="user_permissions[${userId}[roles[chat[ticket]]]]">
        <span class="checkbox_text"></span>
      </label></td>
      <td class="d-none"><label class="checkbox_noborder_intable">
        <input name="user_permissions[${userId}[roles[chat[akaire_file]]]]" type="hidden" value="false"><input id="permission_${userId}_chat_akaire_file" class="mr-2 scale-2 user_permission_checbox" type="checkbox" value="true" name="user_permissions[${userId}[roles[chat[akaire_file]]]]">
        <span class="checkbox_text"></span>
      </label></td>
    </tr>`
  }

  updateMemberPaginationWindow(scope) {
    const root = scope && scope.jquery ? scope[0] : scope;
    if (!root) return;

    const pageItems = Array.from(root.querySelectorAll('li.page-item.page-number[data-index]'));
    if (pageItems.length <= 6) return;

    const activeItem = root.querySelector('li.page-item.page-number.active[data-index]');
    const activePage = Number(activeItem?.getAttribute('data-index') || 1);
    const totalPages = pageItems.length;
    const leftGap = root.querySelector('.gap-left');
    const rightGap = root.querySelector('.gap-right');
    let visiblePages;

    if (activePage <= 4) {
      visiblePages = [1, 2, 3, 4, 5, totalPages];
    } else if (activePage >= totalPages - 3) {
      visiblePages = [1, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      visiblePages = [1, activePage - 1, activePage, activePage + 1, totalPages];
    }

    visiblePages = Array.from(new Set(visiblePages)).filter((page) => page >= 1 && page <= totalPages);

    pageItems.forEach((item) => {
      const page = Number(item.getAttribute('data-index'));
      item.classList.toggle('d-none', !visiblePages.includes(page));
    });

    const sortedPages = [...visiblePages].sort((a, b) => a - b);
    const needsLeftGap = sortedPages[1] && sortedPages[1] - sortedPages[0] > 1;
    const needsRightGap =
      sortedPages.length >= 2 &&
      sortedPages[sortedPages.length - 1] - sortedPages[sortedPages.length - 2] > 1;

    if (leftGap) leftGap.classList.toggle('d-none', !needsLeftGap);
    if (rightGap) rightGap.classList.toggle('d-none', !needsRightGap);

    if (sortedPages[1] && sortedPages[1] - sortedPages[0] === 2) {
      const missingPage = sortedPages[0] + 1;
      const item = root.querySelector(`li.page-item.page-number[data-index="${missingPage}"]`);
      if (item) item.classList.remove('d-none');
      if (leftGap) leftGap.classList.add('d-none');
    }

    if (
      sortedPages.length >= 2 &&
      sortedPages[sortedPages.length - 1] - sortedPages[sortedPages.length - 2] === 2
    ) {
      const missingPage = sortedPages[sortedPages.length - 1] - 1;
      const item = root.querySelector(`li.page-item.page-number[data-index="${missingPage}"]`);
      if (item) item.classList.remove('d-none');
      if (rightGap) rightGap.classList.add('d-none');
    }
  }

  prevPagePermission(ele) {
    const modalEle = ele.closest('#popupInviteMember, .popup-invite-member, .popup-list-permission');
    const ulEle = $(ele).parents('ul.pagination')
    const pageSelected = ulEle.find('li.active')
    const numberPage = Number(pageSelected.attr('data-index'))
    if (numberPage <= 1) return
    pageSelected.removeClass('active')
    ulEle.find(`li[data-index="${numberPage - 1}"]`).addClass('active')
    const listTr = modalEle ? modalEle.querySelectorAll('tbody.permission-row tr.show_permission_tr_list') : []
    for (let i = 0; i < listTr.length; i++) {
      listTr[i].style.display = 'none';
    }
    const listTrShow = modalEle ? modalEle.querySelectorAll(`tr.show_permission_tr_list[data-page="${numberPage - 1}"]`) : []
    for (let i = 0; i < listTrShow.length; i++) {
      listTrShow[i].style.display = '';
    }
    this.updateMemberPaginationWindow(ulEle);
  }

  nextPagePermission(ele, maxPage) {
    const modalEle = ele.closest('#popupInviteMember, .popup-invite-member, .popup-list-permission');
    const ulEle = $(ele).parents('ul.pagination')
    const pageSelected = ulEle.find('li.active')
    const numberPage = Number(pageSelected.attr('data-index'))
    if (numberPage === Number(maxPage)) return
    pageSelected.removeClass('active')
    ulEle.find(`li[data-index="${numberPage + 1}"]`).addClass('active')
    const listTr = modalEle ? modalEle.querySelectorAll('tbody.permission-row tr.show_permission_tr_list') : []
    for (let i = 0; i < listTr.length; i++) {
      listTr[i].style.display = 'none';
    }
    const listTrShow = modalEle ? modalEle.querySelectorAll(`tr.show_permission_tr_list[data-page="${numberPage + 1}"]`) : []
    for (let i = 0; i < listTrShow.length; i++) {
      listTrShow[i].style.display = '';
    }
    this.updateMemberPaginationWindow(ulEle);
  }

  selectPagePermission(ele) {
    const modalEle = ele.closest('#popupInviteMember, .popup-invite-member, .popup-list-permission');
    const page = $(ele).attr('data-index')
    const ulEle = $(ele).parents('ul.pagination')
    const pageSelected = ulEle.find('li.active')
    pageSelected.removeClass('active')
    ulEle.find(`li[data-index="${page}"]`).addClass('active')
    const listTr = modalEle ? modalEle.querySelectorAll('tbody.permission-row tr.show_permission_tr_list') : []
    for (let i = 0; i < listTr.length; i++) {
      listTr[i].style.display = 'none';
    }
    const listTrShow = modalEle ? modalEle.querySelectorAll(`tr.show_permission_tr_list[data-page="${page}"]`) : []
    for (let i = 0; i < listTrShow.length; i++) {
      listTrShow[i].style.display = '';
    }
    this.updateMemberPaginationWindow(ulEle);
  }

  async changeNumberPage(ele, totalObject=null, numberOfPage=null, parentElement = '#popupInviteMember', callFromHeader = false) {
    const widthWindow = $(window).width()
    let modalEle = ele.closest(`div${parentElement}`)

    // iPad teleport fallback: If .filter-content is moved to document.body,
    // we follow _teleportOrigin (the original parent) to identify the correct modal container.
    if (!modalEle) {
      const teleportedModal = ele.closest('.filter-content');
      if (teleportedModal && teleportedModal._teleportOrigin) {
        modalEle = teleportedModal._teleportOrigin.closest(`div${parentElement}`);
      }
    }
    const allTr = modalEle.querySelectorAll('tr.show_permission_tr_list');
    let selector = 'tr.show_permission_tr_list[is-showed="true"]';
    const showMemberAddEle = modalEle.querySelector('span.show-number-member-add');

    if (showMemberAddEle && showMemberAddEle.getAttribute('is-show') === 'true') {
      selector += '[is-new-add="true"]';
    }

    const listTr = modalEle.querySelectorAll(selector);
    numberOfPage ??= Number(ele.textContent.trim());
    totalObject = listTr.length
    const totalEle = Number(totalObject)
    const pagynate = await Shared.fetchPagynateWithJs(totalEle, numberOfPage)
    $(ele).parent().find('.option').removeClass('slted');
    $(ele).addClass('slted')
    if (callFromHeader) {
      $(modalEle).find('.show-number-of-page-js').html(`<b>表示件数</b>     ${numberOfPage}`)
    } else {
      $(modalEle).find('.show-number-of-page-js').html(numberOfPage)
    }
    allTr.forEach(tr => {
      tr.removeAttribute('data-page');
      tr.style.display = 'none'
    });

    listTr.forEach((tr, index) => {
      const page = Math.floor(index / numberOfPage) + 1
      tr.setAttribute('data-page', page)
      tr.style.display = page === 1 ? '' : 'none'
    })
    const newPagy = await Shared.reRenderPagyNate(
      pagynate, 'Project.prevPagePermission(this)', 'Project.selectPagePermission(this)',
      `Project.nextPagePermission(this, '${pagynate}')`
    )
    const pagyContainer = modalEle.querySelector('#render-list-pagynate-of-member-project-author');
    if (pagyContainer) {
      pagyContainer.innerHTML = newPagy
      this.updateMemberPaginationWindow(pagyContainer);
    }
  }

  async changeLegacyNumberPage(ele, totalObject, numberOfPage, parentElement = '#popupInviteMember') {
    const widthWindow = $(window).width()
    const modalEle = ele.closest(`div${parentElement}`)
    const totalEle = Number(totalObject)
    const pagynate = await Shared.fetchPagynateWithJs(totalEle, numberOfPage)
    let listTr = modalEle.querySelectorAll('tr.show_permission_tr_list')
    $(ele).parent().find('.option').removeClass('slted');
    $(ele).addClass('slted')
    $('.show-number-of-page-js').html(`表示件数   ${numberOfPage}`)
    if (widthWindow <= 768) $(ele).closest('div.modal').modal('hide')
    if (numberOfPage > 30 && widthWindow <= 768) {
      Shared.loadingIndicator()
      await this.renderPages(listTr, pagynate, modalEle, numberOfPage)
      return
    }
    for (let i = 1; i <= pagynate; i++) {
      let numberEleOfPage = 0;
      if (numberEleOfPage === numberOfPage) {
        numberEleOfPage = 0
        continue
      }
      for (let x = 0; x < listTr.length; x ++) {
        listTr[x].style.display = 'none'
        const isCalculator = listTr[x].getAttribute('calculator-page')
        if (numberEleOfPage < numberOfPage && !isCalculator) {
          listTr[x].setAttribute('calculator-page', 'true')
          listTr[x].setAttribute('data-page', i)
          numberEleOfPage += 1
        }
      }
    }
    for (let i = 0; i < listTr.length; i++) {
      listTr[i].removeAttribute('calculator-page')
    }
    const listPageOne = modalEle.querySelectorAll('tr[data-page="1"]')
    for (let i = 0; i < listPageOne.length; i++) {
      listPageOne[i].style.display = '';
    }
    const newPagy = await Shared.reRenderPagyNate(
      pagynate, 'Project.prevPagePermission(this)', 'Project.selectPagePermission(this)',
      `Project.nextPagePermission(this, '${pagynate}')`
    )
    document.getElementById('render-list-pagynate-of-member-project-author').innerHTML = newPagy
  }

  async renderPages(listTr, pagynate, modalEle, numberOfPage) {
    for (let i = 1; i <= pagynate; i++) {
      let numberEleOfPage = 0;
      if (numberEleOfPage === numberOfPage) {
        numberEleOfPage = 0
        continue
      }
      for (let x = 0; x < listTr.length; x ++) {
        if (numberEleOfPage < numberOfPage) {
          listTr[x].setAttribute('data-page', i)
          numberEleOfPage += 1
        }
      }
    }
    let newListTr = await this.chunkArray(Array.from(listTr), 10)
    listTr = null
    await this.removeInTr(newListTr)
    newListTr = null
    const newPagy = await Shared.reRenderPagyNate(
      pagynate, 'Project.prevPagePermission(this)', 'Project.selectPagePermission(this)',
      `Project.nextPagePermission(this, '${pagynate}')`
    )
    document.getElementById('render-list-pagynate-of-member-project-author').innerHTML = newPagy
    $('.preloader').fadeOut();
  }

  async removeInTr(chunkedArrays) {
    for (const array of chunkedArrays) {
      requestAnimationFrame(() => {
        for (let i = 0; i < array.length; i++) {
          if (array[i].getAttribute('data-page') === '1') {
            if (array[i].style.display !== '') array[i].style.display = ''
          } else {
            if (array[i].style.display !== 'none') array[i].style.display = 'none'
          }
        }
      });
      await new Promise(resolve => {
        setTimeout(resolve, 600)
      })
    }
  }

  async chunkArray(array, chunkSize) {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
  }


  checkAllOrCanCelCheckAllMember(ele) {
    if($(ele).is(':checked')) {
      this.checkAllMemberOfProject(ele)
    } else {
      this.unCheckAllMemberOfProject(ele)
    }
  }

  checkAllMemberOfProject(ele) {
    const modalEle = $(ele).parents('div#popupInviteMember')
    const canCheck = $(ele).data('can-check');
    const typeCurrentCompanyInProject = $(ele).data('type-current-company-in-project');
    const listObjectEle = modalEle.find('tr.show_permission_tr_list').toArray()
    listObjectEle.forEach((tr) => {
      const checkMemberEle = $(tr).find('input.check-box-check-member')
      if (typeCurrentCompanyInProject !== 'collaborator' || canCheck.includes(Number(checkMemberEle.data('user-id')))) {
        if (!checkMemberEle.is(':checked')) {
          checkMemberEle.trigger('click')
        }
      }
    })
  }

  unCheckAllMemberOfProject(ele) {
    const modalEle = $(ele).parents('div#popupInviteMember')
    const listObjectEle = modalEle.find('tr.show_permission_tr_list').toArray()
    const notUncheck = $(ele).data('not-uncheck')
    const canCheck = $(ele).data('can-check');
    const typeCurrentCompanyInProject = $(ele).data('type-current-company-in-project');
    const dataUserDelete = $('.list-user-delete');
    listObjectEle.forEach((tr) => {
      const checkMemberEle = $(tr).find('input.check-box-check-member')
      if (typeCurrentCompanyInProject !== 'collaborator' || canCheck.includes(Number(checkMemberEle.data('user-id')))) {
        if (checkMemberEle.is(':checked') && !notUncheck.includes(Number(checkMemberEle.data('user-id')))) {
          dataUserDelete.val(`${dataUserDelete.val()}${Number(checkMemberEle.data('user-id'))},`)
          checkMemberEle.trigger('click')
          checkMemberEle.prop('checked', false)
        }
      }
    })
  }

  openModalCreateTask(projectId, count_task, text_task_akaire, project_name) {
    const projectName = $(`.project-name-link-${projectId}`).text()
    const modalCreate = $("#createTaskProjectModal");
    modalCreate.attr('data-project-id', projectId)
    modalCreate.find(".btn-project-new.task").attr('href', Routes.owner_new_tasks_path(projectId))
    modalCreate.find("#taskName").val(`${text_task_akaire}${count_task + 1}`)
    modalCreate.find('.title-project-name').html(projectName)
    modalCreate.find('form').attr('action', Routes.create_from_project_list_owner_project_tasks_path(projectId))
    modalCreate.modal('show')
  }

  openModalCreateTaskFromTaskList(projectId, count_task, text_task_akaire, isAkapon) {
    let modalCreateId = ''
    if (isAkapon == 'true') {
      modalCreateId = '#selectProjectTaskModalAkapon'
      let modalCreate = $(modalCreateId);
      modalCreate.find('#selectProjectId').val(projectId).change()
      modalCreate.find('.edit-project-name').addClass('disabled-edit-project-name')
      this.switchToCreateTask()
      modalCreate.find('.last-step').attr('onclick', "$('#selectProjectTaskModalAkapon').modal('hide')")
      $('#listTaskModal').modal('hide')
      modalCreate.modal('show')
    } else {
      modalCreateId = '#createTaskFromListTaskModal'
      let modalCreate = $(modalCreateId);
      modalCreate.attr('data-project-id', projectId)
      modalCreate.find(".btn-project-new.task").attr('href', Routes.owner_new_tasks_path(projectId))
      modalCreate.find("#taskName").val(`${text_task_akaire}${count_task + 1}`)
      modalCreate.find('form').attr('action', Routes.create_from_project_list_owner_project_tasks_path(projectId))
      $('#listTaskModal').modal('hide')
      modalCreate.modal('show')
    }

    $(modalCreateId).on('hidden.bs.modal', function () {
      $('#listTaskModal').modal('show')
    })
  }

  openCreateProjectModal(isCreate, isAkapon) {
    if (isCreate === 'true' || isCreate === true) {
      this.closeCreateProjectSidebarPanels();
      $('#CreateProjectOptionsModal').removeAttr('data-tm-parent-modal-id');
      $('#CreateProjectOptionsModal').modal('show');
    } else {
      Shared.showModalForElement($('#errorModalForProject'));
    }
  }

  createProjectWithoutFile() {
    this.closeCreateProjectSidebarPanels();
    const optionsModal = $('#CreateProjectOptionsModal');
    const modal = $('#createProjectModal');
    modal.attr('data-tm-parent-modal-id', 'CreateProjectOptionsModal');
    modal.find('.dismiss-modal').addClass('d-none');
    modal.find('.show-again-area').addClass('d-none');
    optionsModal.off('hidden.bs.modal.createProjectWithoutFile');
    optionsModal.one('hidden.bs.modal.createProjectWithoutFile', function () {
      modal.modal('show');
    });
    optionsModal.modal('hide');
  }

  switchToCreateProjectTask(isCreate, isAkapon) {
    if (isCreate === 'true') {
      $('#selectProjectTaskModalAkapon').modal('hide')
      $('#createProjectModalAkapon').modal('show')
      $('#createProjectModalAkapon').find('.show-again-area').addClass('d-none')

      $('#createProjectModalAkapon').find('.step-create-project').html('１，赤入れのプロジェクトを作成してください。')
      $('#createProjectModalAkapon').find('.step-create-task').html('２，新しい赤入れを作成してください。')

      const buttonBack = $('#createProjectModalAkapon').find('.back-to-last-step');
      buttonBack.attr('data-is-switch', 'true')
      buttonBack.attr('onclick', 'Project.switchToCreateProject()')
      buttonBack.removeClass('d-none')
      return
    }

    event.preventDefault();
    if (isAkapon) {
      $( "#errorModalForProject" ).modal('show');
    } else {
      Popup.alert(I18n.t('projects.cannot_create_with_plan'))
    }
  }

  switchToCreateProject() {
    $('#selectProjectTaskModalAkapon').modal('show')
    $('#createProjectModalAkapon').modal('hide')
  }

  submitQuickCreateTask(modal_id){
    const modalCreate = $(modal_id);
    const action = modalCreate.find('form').attr('action')
    modalCreate.find('form').find('#submit-create-task').click()
  }

  showSettingPicProject(projectId, isAfterCreateProject = false, isInviteNewMember = false) {
    const url = Routes.project_participants_owner_project_path(projectId)
    Shared.callAjax(url, {is_after_create_project: isAfterCreateProject, is_invite_new_member: isInviteNewMember}, 'script', 'GET')
  }

  showListTaskProject(element, projectId, item) {
    let data = {}
    if( element ) data = { items_each_page: item }
    const url = Routes.get_list_task_of_project_owner_project_path(projectId)
    Shared.callAjax(url, data, 'script', 'get')
  }

  showListAkaireFileProject(element, projectId, item) {
    let data = {}
    if( element ) data = { items_each_page: item }
    const url = Routes.get_list_akaire_file_of_project_owner_project_path(projectId)
    Shared.callAjax(url, data, 'script', 'get')
  }

  enableButtonSubmit(element, id){
    const value = $(element).val()
    if(value.length > 0){
      $(id).find(".submit-create").removeClass('disabled')
    } else {
      $(id).find(".submit-create").addClass('disabled')
    }
  }

  hideSettingMemberModal() {
    if($('#popupInviteMember').find('#element-is-change').val() == 'true') {
      Popup.confirm(
        `<div>選択済みのメンバーはリセットされます。<br>キャンセルしてよろしいですか？</div>`,
        {
          success: () => {
            Visiable.hide('#popupInviteMember')
            $('.modal-backdrop').remove();
          },
          cancel: () => {},
          cancelBtn: 'true',
          confirmText: 'OK',
          cancelText: 'キャンセル',
          width: 'auto'
        }
      )
    } else {
      Visiable.hide('#popupInviteMember')
      $('.modal-backdrop').remove();
    }
  }

  hideSettingMemberModalAfterCreate(project_id) {
    Popup.confirm(
      `<div>選択済みのメンバーはリセットされます。<br>初期設定時のメンバーのみが招待されます。 <br>キャンセルしてよろしいですか？</div>`,
      {
        success: () => {
          const url = Routes.owner_send_mail_to_default_permission_path(project_id)
          Shared.callAjax(url, {}).done(function(data) {
            $('.setting_member_after_create').remove();
            $('.modal-backdrop').hide();
          })
        },
        cancel: () => {
          $('#popupInviteMember').show();
        },
        cancelBtn: 'false',
        confirmText: 'OK',
        width: 'auto'
      }
    )
  }

  settingShowAgainNewProject(element) {
    const url = Routes.setting_show_again_new_project_owner_users_path()
    const check_status = $(element).is(":checked")
    Shared.callAjax(url, { checked: check_status }, 'script', 'POST')
  }

  settingShowAgainConfirmTypeTask(element) {
    const url = Routes.setting_show_again_confirm_type_task_owner_users_path()
    const check_status = $(element).is(":checked")
    Shared.callAjax(url, { checked: check_status }, 'script', 'POST')
  }

  settingNotifyShowAgain(element, type) {
    const url = Routes.setting_show_again_notify_owner_users_path()
    const check_status = $(element).is(":checked")
    $(`#tbody-list-${type}`).attr('data-show-confirm-again', check_status)
    Shared.callAjax(url, { checked: check_status, type: type }, 'script', 'POST')
  }

  getCompanyWithType(element) {
    var type_text = {
      owners: { type: 'owner', text: 'チーム' },
      suppliers: { type: 'supplier', text: '仕入先' },
      clients: { type: 'client', text: '販売先' },
      collaborators: { type: 'collaborator', text: '外部' }
    }
    let project_id = $('#projectId').val();
    const company_type = $(element).val();
    $('#inviteExistUserByEmail').find('#permission_type').val(type_text[company_type].type)
    $('.company-type-text').text(type_text[company_type].text);

    if (company_type !== 'owners') {
      if (!$('#select_current_company').hasClass('d-none')) $('#select_current_company').addClass('d-none')
      $('#select_company_by_type').removeClass('d-none')
      $('#button_add_new_member').addClass('d-none').css('width', '100%')
    } else {
      $('#select_current_company').removeClass('d-none')
      $('#select_company_by_type').addClass('d-none')
      $('#button_add_new_member').removeClass('d-none').css('width', 'calc(100% - 30px)')
    }

    if(company_type == 'clients' && $(element).attr('has_client') == 'true') {
      $('#button_add_new_by_email').addClass('d-none')
    } else {
      $('#button_add_new_by_email').removeClass('d-none')
    }

    const url = Routes.owner_get_company_by_company_type_path(project_id);
    const data = {
      'company_type': $(element).val()
    };
    $('#button_add_member_of_partner').addClass('d-none')
    $('#js-select_users_invites').empty();
    this._handleFetchData(url, data, 'company').then(() => {
      $('#js_select_company_invites_task').val($("#js_select_company_invites_task option:last").val()).trigger('change')
    });
  }

  getUserWithCompany(ele) {
    let project_id = $('#projectId').val();
    let company_id = $(ele).val();
    const company_type = InviteUserShare.getCompanyType();
    InviteUserShare.updateCompanyTypeText(company_type)
    const disableValues = $(ele).data('participant-ids').toString().split(',').map(Number);
    const unSubmitValues = []

    $('.flex-table-authority #member_id').not('.invite_add_block #member_id').map(function () {
      const v = Number(this.value);
      if (!Number.isNaN(v)) {
        unSubmitValues.push(v);
      }
    })

    $('#inviteExistUserByEmail').find('#permission_type').val(company_type.slice(0, -1))
    if(company_type == 'owners') {
      $('#button_add_member_of_partner').addClass('d-none')
      $('#button_add_new_member').removeClass('d-none')
    } else {
      $('#button_add_member_of_partner').removeClass('d-none')
      $('#button_add_new_member').addClass('d-none')
    }
    if (company_id === 'invite_company') {
      $(ele).closest('#select_company_by_type').find('.btn.btn-mint').trigger('click');
      return;
    }
    $('#inviteExistUserByEmail').find('#company_id').val(company_id)
    const url = Routes.owner_list_user_not_user_permission_path(project_id);
    const data = {
      'company_id': company_id,
      'company_type': company_type
    };
    this._handleFetchData(url, data, 'user', disableValues, unSubmitValues).then(() => {
      InviteUserShare.disableInvitedUserOptions('#js-select_users_invites')
    });
  }

  removeDisabledBtnInvite(element) {
    const modalEle = $(element).parents('div.modal-body');
    const userSelect = modalEle.find('#js-select_users_invites').val()
    if (userSelect && userSelect !== '') {
      $(element).parents('div.modal-body').find('#inviteAdd').removeClass('disabled');
    } else {
      $(element).parents('div.modal-body').find('#inviteAdd').addClass('disabled');
    }
  }

  _handleFetchData(url, dataAjax, dataType, disableValues = [], unSubmitValues = []) {
    const project = this
    const idRenderData = dataType === 'company' ? 'js_select_company_invites_task' : 'js-select_users_invites'
    return Shared.callAjax(url, dataAjax).done(function(data) {
      if (data.length === 0) return
      let dataRender = [
        `<option value="" selected disabled></option>`,
        ...data.map(user => {
          const disabled = disableValues.includes(user.id) || unSubmitValues.includes(user.id) ? 'disabled' : ''
          const surfix = disableValues.includes(user.id) ? '（招待済み）' : ''
          const unSubmitSurfix = unSubmitValues.includes(user.id) ? '（選択済み）' : ''
          return `<option value="${user.id}" ${disabled}>${user.name}${unSubmitSurfix || surfix}</option>`
        })
      ]
      $(`#${idRenderData}`).html(dataRender.join(""));
      project.removeDisabledBtnInvite($(`#${idRenderData}`))
    }).fail(function(data) {
      Popup.alert(I18n.t('task.fetch_company_error'), 'warning');
    })
  }

  openAddPicModal(resetValues = false) {
    if (resetValues) {
      if ($('#js_select_company_type_task').length > 0) {
        $('#js_select_company_type_task').val('');
        $('#js_select_company_invites_task').empty();
        $('#js-select_users_invites').empty();
        $('#button_add_new_by_email').addClass('d-none')
        $('#button_add_member_of_partner').addClass('d-none')
        $('#button_add_new_member').addClass('d-none')
        $('#select_company_by_type').removeClass('d-none')
        $('#select_current_company').addClass('d-none')
      } else {
        $('#js_select_company_invites_task').val('');
        $('#js-select_users_invites').empty();

        if($('#current_company_id').length > 0) {
          this.getUserWithCompany('#current_company_id');
          $('#button_add_new_member').removeClass('d-none')
        } else {
          $('#button_add_member_of_partner').addClass('d-none')
        }
      }
      $('#add_new_email_permission').val('');
      $('#add_new_email_permission_type').val('')
    }

    if($('#js-select_users_invites').val() == 'invite_member') {
      $('#js-select_users_invites').val('');
    }

    if ($('#js_select_company_invites_task').val() == 'invite_company') {
      $('#js_select_company_invites_task').val('');
    }

    $("#personInChargeOfObject").modal("hide")
    $("#inviteByEmail").modal("hide")
    this.setModalBackParent('#addPermissionProjectAuthor', 'popupInviteMember')
    Shared.appendSelect2('#addPermissionProjectAuthor', '#js_select_company_invites_task', 'アカウント名を選択してください', 'アカウント名を検索', null, InviteUserShare.removeCompanyPrefixSuffix)
    Shared.appendSelect2('#addPermissionProjectAuthor', '#js_select_company_type_task', '取引種類を選択してください', '', InviteUserShare.customOptionCompanyType, InviteUserShare.removeCompanyPrefixSuffix)
    Shared.appendSelect2('#addPermissionProjectAuthor', '#js-select_users_invites', 'メンバー名を選択してください', 'メンバー名を検索', null)
    $("#addPermissionProjectAuthor").modal("show")
  }

  nextStepCreateTask(element, modal_id) {
    const parent = $(element).closest(modal_id);
    const projectName = parent.find('#projectName').val()
    const data = { name: projectName, id: parent.find('#current_project_id').val() }
    const url = Routes.quick_create_owner_projects_path()
    const project = this;
    Shared.callAjax(url, { project: data }, 'json', 'post')
    .done(function(data) {
      parent.find(".btn-project-new.task").attr('href', Routes.owner_new_tasks_path(data.project_id, {transit_akaire: 'true'}))
      parent.find('.submit-create').removeClass('d-none');
      parent.find('.project-area').addClass('d-none');
      parent.find('.project-preview').removeClass('d-none');
      parent.find('.task-area').removeClass('d-none');
      parent.find('.next-step').addClass('d-none');
      parent.find('.back-to-last-step').attr('onclick', "Project.resetProjectName('#createProjectModalAkapon')")
      parent.find('.back-to-last-step').removeClass('d-none')
      parent.find('#current_project_id').val(data.project_id)
      parent.find('.project-name-preview').html(project.truncateProjectName(projectName));
    }).fail(function(response) {
      if (!!response.responseJSON['error_quantity']) {
        $('#errorModalForProject').modal('show')
        $('#createProjectModalAkapon').modal('hide')
      }
    })
  }

  resetProjectName(modal_id) {
    const parent = $(modal_id);
    const buttonBack = parent.find('.back-to-last-step');
    parent.find('.submit-create').addClass('d-none');
    parent.find('.project-area').removeClass('d-none');
    parent.find('.project-preview').addClass('d-none');
    parent.find('.task-area').addClass('d-none');
    parent.find('.next-step').removeClass('d-none')
    if(buttonBack.attr('data-is-switch', 'true')) {
      buttonBack.attr('onclick', 'Project.switchToCreateProject()')
    } else {
      buttonBack.addClass('d-none')
    }
  }

  selectExistProject(element, text_task_akaire) {
    const modal = $('#selectProjectTaskModalAkapon')
    const project_id = $('#projectId').val();
    const project = this;
    if(project_id) {
      const project_name = $(element).find("option:selected").text();
      modal.find('.project-area').addClass('d-none');
      modal.find('.project-preview').removeClass('d-none');
      modal.find('.project-name-preview').html(project.truncateProjectName(project_name))
      modal.find('.show-again-area').addClass('d-none')

      const url = Routes.get_list_task_of_project_owner_project_path(project_id)
      Shared.callAjax(url, {}, 'json', 'get').done(function(data) {
        const option = modal.find('#selectTaskId');
        option.empty().append(`<option value=''>${text_task_akaire}名から検索</option>`)
        modal.find('#taskName').val(`${text_task_akaire}${data.tasks.length + 1}`)
        modal.find('.next-step').removeClass('d-none')
        modal.find('.last-step').removeClass('d-none')
        modal.find(".btn-project-new.task").attr('href', Routes.owner_new_tasks_path(project_id, {transit_akaire: 'true'}))
        if(data.can_add_task) modal.find('.hint-and-transit-create').removeClass('disabled')
        var tasks = data.tasks;
        for(let i = 0; i < tasks.length; i++){
          option.append(`<option value="${tasks[i].id}" data-category="${tasks[i].category}">${tasks[i].name}</option>`);
        }
        Shared.appendSelect2Task('#selectProjectTaskModalAkapon', '#selectTaskId')
      })
    }
  }

  resetSelectExistProject() {
    const modal = $('#selectProjectTaskModalAkapon')
    modal.find('.project-area').removeClass('d-none');
    modal.find('.project-preview').addClass('d-none');
    modal.find('.next-step').addClass('d-none')
    modal.find('.next-step').addClass('disabled');
    modal.find('.last-step').addClass('d-none')
    modal.find('.project-name-preview').html('');
    modal.find('#task-name-select').val('');
    modal.find('#selectProjectId').val('').change();
    modal.find('#selectTaskId').empty().append('<option value="">赤入れ名から検索</option>');
    modal.find('.task-category').empty()
    modal.find('.select-task-area .hint-and-transit-create').addClass('disabled')
  }

  switchToCreateTask() {
    const parent = $('#selectProjectTaskModalAkapon');
    parent.find('#flag_create_task').val('true');
    parent.find('.select-task-area').addClass('d-none');
    parent.find('.create-task-area').removeClass('d-none');
    parent.find('.last-step').attr('onclick', "Project.backToSelectStep()")
    if(parent.find('#taskName').val().length == 0) {
      parent.find('.next-step').addClass('disabled')
    } else {
      parent.find('.next-step').removeClass('disabled')
    }
  }

  backToSelectStep() {
    const parent = $('#selectProjectTaskModalAkapon');
    parent.find('.select-task-area').removeClass('d-none');
    parent.find('.create-task-area').addClass('d-none');
    parent.find('.last-step').attr('onclick', "Project.resetSelectExistProject()")
    parent.find('#flag_create_task').val('false');
    if(parent.find('#selectTaskId').val()) {
      parent.find('.next-step').removeClass('disabled')
    } else {
      parent.find('.next-step').addClass('disabled')
    }
  }

  selectExistTask(element) {
    const modal = $('#selectProjectTaskModalAkapon');
    const category = $(element).find('option:selected').attr('data-category')
    modal.find('.next-step').removeClass('disabled');
    if(category == 'web') {
      modal.find('.task-category').empty().append('<img src=' + gon.svg.web + ' class="icon mr-1" width="35" height="25"></img>')
    } else if(category == 'video') {
      modal.find('.task-category').empty().append('<img src=' + gon.svg.video + ' class="icon mr-1" width="35" height="25"></img>')
    } else {
      modal.find('.next-step').addClass('disabled');
      modal.find('.task-category').empty()
    }
  }

  showTotalFileSize(file_size) {
    const modal = $('#totalFileSizeProjectModal');
    modal.find('.file-size-content').html(`総容量：${file_size}`)
    modal.modal('show')
  }

  changeStatusSp(project_id, status) {
    $('.modal-status-project').modal('hide')
    $('#tbody-list-project').find(`.select-status-${project_id}`).val(status).change();
  }

  truncateProjectName(text, count = 20) {
    if(!text) return ''

    const dots = '...'
    let textCount = count;

    if(window.innerWidth <= 820) textCount = 10

    if(window.innerWidth <= 550) textCount = 7

    const projectName = text.slice(0, textCount)
    if(projectName.length >= textCount) {
      return projectName + dots
    } else {
      return projectName
    }
  }

  submitCreateTask(element, modal_id, hide_confirm_type) {
    const parent = $(modal_id);
    const confirm_modal = $('#confirmCreateTaskAkapon')
    const project = this;
    if(hide_confirm_type == 'true') {
      parent.find('form#new_project').submit()
    } else {
      parent.addClass('d-none')
      confirm_modal.find('.project-name').html(parent.find('.project-name-preview').text())
      confirm_modal.find('.task-name').html(project.truncateProjectName(parent.find('#taskName').val()))
      if(parent.find('#select_category').val() == 'video') {
        confirm_modal.find('.task-type').html('動画')
      } else {
        confirm_modal.find('.task-type').html('WEB')
      }
      confirm_modal.modal('show')
      confirm_modal.find('.submit-transit-akaire').attr('onclick', `$('${modal_id}').find('form#new_project').submit()`)
      confirm_modal.on('hidden.bs.modal', function () {
        parent.removeClass('d-none')
      })
    }
  }

  submitSelectOrCreateTask(element, modal_id, hide_confirm_type) {
    if($(modal_id).find('#flag_create_task').val() != 'true') {
      return $(modal_id).find('form#new_project').submit()
    }
    this.submitCreateTask(element, modal_id, hide_confirm_type)
  }

  closePopupInviteMember() {
    Visiable.hide('#popupInviteMember')
    $('.modal-backdrop').remove();
  }

  async actionChangeNumberPage(ele, totalObject, parentElement = '#popupInviteMember') {
    let numberOfPage = $(ele).val();
    this.changeNumberPage(ele, totalObject, numberOfPage, parentElement)
  }

  acceptRequestAddMember(requestId) {
    const eleContainer = $('#request-add-member-to-admin');
    const name = eleContainer.find('input[name="request[name]"]').val();
    const email = eleContainer.find('input[name="request[email]"]').val();
    const email_regex = /(\b[^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/;
    if (!!name && !!email) {
      if (!email_regex.test(email)) {
        Popup.alert(`メールアドレスが正しくありません。`);
        return;
      }

      if (Shared.checkValidationUserName(name)) {
        Popup.alert('「お名前」に利用できない文字があります。<br>お名前を変更してください。')
        return;
      }
      const url = Routes.accept_owner_request_admin_to_invite_member_path(requestId)
      Shared.callAjax(url, { email: email, name: name})
      .done(function(data) {
        $("#requestToAdminAddMember").modal("hide");
        Popup.alert(`${name}さんをメンバーに招待しました。`);
      })
      .fail(function(data) {
        if (data.responseJSON.email_exists) {
          Popup.alert(`このメールアドレスは既に存在します。`);
        }
      })
    } else {
      Popup.alert('空白にはできません。');
    }
  }

  enableButtonInput(element) {
    $(element).addClass('d-none')
    $('.password-field').removeClass('d-none')
    $('.password-field').focus()
    $('.password-field').on("focusout", function() {
      if($(this).val() == '') {
        $(element).removeClass('d-none')
        $('.password-field').addClass('d-none')
      }
    })
  }

  checkValidationInputUser(user_name) {
    let submit_flag = true
    let name = $('#user_name').val();
    let password = $('#user_password').val();
    let passwordConfirmation = $('#user_password_confirmation').val();

    let expressionPassword = /(?=.*[a-zA-Z])(?=.*\d).{8,32}/
    let RegexPassword = new RegExp(expressionPassword);
    if (Shared.checkValidationUserName(name)) {
      Popup.alert('「お名前」に利用できない文字があります。<br>お名前を変更してください。')
      $('#user_name').val(user_name)
      submit_flag = false;
    } else {
      if(!password.match(RegexPassword)) {
        Popup.alert('英・数を各1文字以上で最低8文字以上32文字以下入力してください。E.g: abAB1122')
        submit_flag = false;
      }

      if (password != passwordConfirmation) {
        Popup.alert('パスワードが違います。')
        submit_flag = false;
      }
    }

    if(submit_flag) $('button.sign-up-user').parents('form').submit();
  }

  backToModalCreateProject() {
    this.closeCreateProjectSidebarPanels();
    const createProjectModal = $('#createProjectModal');
    const optionsModal = $('#CreateProjectOptionsModal');
    createProjectModal.attr('data-tm-parent-modal-id', 'CreateProjectOptionsModal');

    createProjectModal.off('hidden.bs.modal.backToModalCreateProject');
    createProjectModal.one('hidden.bs.modal.backToModalCreateProject', function () {
      optionsModal.modal('show');
    });
    createProjectModal.modal('hide')
  }

  closeCreateProjectSidebarPanels() {
    $('#sidebar-recently, #recently-projects, #recently-tasks').addClass('d-none');
  }

  showModalEditProjectName() {
    $('#modalAfterCreateProject').modal('hide')
    $('#modalEditProjectNameAfterCreate').modal('show')
  }

  backToModalAfterCreateProject() {
    $('#modalEditProjectNameAfterCreate').modal('hide')
    $('#modalAfterCreateProject').modal('show')
  }

  updateProjectName(project_id) {
    const projectName = $('#projectEditName').val()
    Shared.callAjax(
      Routes.update_project_name_owner_project_path(project_id),
      {project_name: projectName},
      '',
      'put'
    ).done((data) => {
      $('#modalEditProjectNameAfterCreate').modal('hide')
      $('#modalAfterCreateProject').modal('show')
      $('#modalAfterCreateProject').find('.show-project-name').text(projectName.slice(0, 10) + '...')
      $(`.project-name-link-${project_id}`).text(projectName)
      $(`#modalSelectStatus-${project_id}`).find('span.text-ellipsis').text(projectName)
      $(`#modalMenu-${project_id}`).find('span.text-ellipsis').text(projectName)
    }).fail((data) => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  showSettingPicProjectInAfterCreateProject(projectId) {
    Shared.hideModalForElement('#modalAfterCreateProject')
    this.showSettingPicProject(projectId, true)
  }

  notInviteMemberInAfterCreateProject(projectId) {
    $('#number-member-invite-after-create-project').find(
      '.number-add-member-invite'
    ).text(`0名`)
    $('#number-member-invite-after-create-project').removeClass('d-none')
    $('#modalAfterCreateProject').find('button').addClass('d-none')
  }

  hideEditProjectName(ele, projectId) {
    ele.parent().find(`.project-name-link-${projectId}`).removeClass('d-none')
    ele.parent().find('.edit-project-name-img').removeClass('d-none')
    ele.addClass('d-none')
    ele.parent().find('.edit-project-name-backdrop').addClass('d-none')
  }

  handleChangeProjectName(input, projectId) {
    const newName = input.val()
    if (newName.length > 0) {
      Shared.callAjax(
        Routes.update_project_name_owner_project_path(projectId),
        {project_name: newName},
        '',
        'put'
      ).done((data) => {
        input.parent().find(`.project-name-link-${projectId}`).text(newName)

        location.reload()
      }).fail((data) => {
        Popup.alert(I18n.t('shared.one_error_please_try_again'))
      })
    }

    this.hideEditProjectName(input, projectId)
  }

  showEditProjectName(ele, projectId) {
    $(ele).parent().find(`.project-name-link-${projectId}`).addClass('d-none')
    $(ele).addClass('d-none')

    const nameInput = $(ele).parent().find('.input-project-text-name')
    const editBackdrop = $(ele).parent().find('.edit-project-name-backdrop')
    editBackdrop.removeClass('d-none')
    nameInput.removeClass('d-none')
    nameInput.trigger("focus")

    editBackdrop.on('click', () => {
      editBackdrop.off('click')

      this.handleChangeProjectName(nameInput, projectId)
    })

    nameInput.on('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        this.handleChangeProjectName(nameInput, projectId)
      }
    })
  }

  showMemberOfEntity(element, entityId, type) {
    if(type == 'project') {
      const url = Routes.project_approve_participants_owner_project_path(entityId)
      Shared.callAjax(url, {call_from_header: true}, 'script', 'GET')
    } else if(type == 'task') {
      const projectID = $(element).data('project-id')
      const url = Routes.owner_project_task_get_list_approve_participants_path(projectID, entityId)
      Shared.callAjax(url, { task_id: entityId, call_from_header: true }, 'script', 'GET')
    } else if(type == 'ticket') {
      const projectID = $(element).data('project-id')
      const taskId = $(element).data('task-id')
      const url = Routes.owner_project_ticket_get_list_approve_participants_path(projectID, entityId)
      Shared.callAjax(url, { task_id: taskId, work_id: entityId, call_from_header: true }, 'script', 'GET')
    } else if(type == 'akaire_file') {
      const projectId = $(element).data('project-id')
      const url = Routes.project_approve_participants_akaire_file_index_path(projectId)
      Shared.callAjax(url, { akaire_file_id: entityId, call_from_header: true }, 'script', 'GET')
    }
  }

  backToMemberListModal() {
    const recentFileMenuModalId = window.__tmLastFileMenuModalId || ''
    this.setModalBackParent('#popupInviteMember', recentFileMenuModalId)
    $('.popup-invite-member').removeClass('d-none')
    $('.popup-invite-member').find('.page-item[data-index="1"] .page-link').first()[0].click();
  }

  showCreateTaskOptionsModal(projectId) {
    $(`#CreateTaskOptionsNewModal-${projectId}`).modal('show');
  }

  clickBtnShowSelectBackground(projectId, perPage = 5) {
    $('.preloader').fadeIn();
    const url = Routes.get_project_background_owner_project_path(projectId)
    Shared.callAjax(url, { items_each_page: perPage }, 'script', 'get').done(function(data) {})
    .fail(function(data) {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  clickBtnChooseUploadBackground(event) {
    event.preventDefault();
    $('.input-upload-bg-multiple').trigger('click');
  }

  chooseImageUpload(projectId, event) {
    const REGEX_FILE_EXTENSIONS = /(\.jpg|\.gif|\.png|\.jpeg)$/i;
    const files = event.target.files;

    if (!files.length) return;

    if (files.length > 50) {
      Popup.alert('１画像10MB以内・画像数は50個以内となります。')
      return;
    }

    let formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      if (!REGEX_FILE_EXTENSIONS.test(files[i].name)) {
        $('.input-upload-bg-multiple').val("");
        alert("PNG・GIF・JPGファイルがアップロード可能");
        return;
      }

      formData.append("files[]", files[i]);
    }

    Shared.callAjax(
      Routes.upload_background_owner_project_path(projectId),
      formData, 'script', 'POST', true, true
    );
  }

  closeBackgroundViewer() {
    $('#project-background-viewer').addClass('hidden')
    $('#viewer-project-background').attr('src', '')
    $('#project-background-viewer .btn-primary').off('click.bgviewer')
    $('#project-background-viewer .close-btn').off('click.bgviewer')
  }

  viewBackground(ele, projectId, backgroundId) {
    const imageUrl = $(ele).attr('src')

    $('#viewer-project-background').attr('src', imageUrl)
    $('#project-background-viewer').removeClass('hidden')

    $('#project-background-viewer .btn-primary').on('click.bgviewer', () => {
      this.selectBackground(projectId, backgroundId)
    })

    $('#project-background-viewer .close-btn').on('click.bgviewer', () => {
      this.closeBackgroundViewer()
    })
  }

  selectBackground(projectId, backgroundId) {
    const url = Routes.select_background_owner_project_path(projectId)

    Shared.callAjax(url, { background_id: backgroundId }, 'json', 'patch').done(function(data) {
      location.reload()
    })
    .fail(function(data) {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  showDeleteBackground(projectId, backgroundId) {
    const $modalDelete = $(`#modalDeleteBg-${projectId}-${backgroundId}`);
    const $parentHeader = $(`#modalSelectBg-${projectId}`).find('.tm-file-header-title-text');

    if ($parentHeader.length) {
      const $icon = $parentHeader.find('img, i').first().clone();
      $parentHeader.find('.text-content').remove();
      $parentHeader.empty().append($icon).append(' 背景画像を削除する');
    }

    $modalDelete.one('hidden.bs.modal', () => {
      if ($parentHeader.length) {
        const $icon = $parentHeader.find('img, i').first().clone();
        $parentHeader.empty().append($icon).append(' 背景画像を選択');
      }
    });

    Shared.showModalForElement($modalDelete);
  }

  deleteBackground(projectId, backgroundId) {
    const url = Routes.delete_background_owner_project_path(projectId)

    Shared.callAjax(url, { background_id: backgroundId }, 'json', 'delete').done(function(data) {
      $('.selec-bg-list').find(`.background-${backgroundId}`).remove()
      Shared.hideModalForElement(`#modalDeleteBg-${projectId}-${backgroundId}`)
    })
    .fail(function(data) {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  closeDeleteBackgroundModal(projectId, backgroundId) {
    Shared.hideModalForElement(`#modalDeleteBg-${projectId}-${backgroundId}`)
  }

  closeModalSelectBg(projectId) {
    Shared.hideModalForElement(`#modalSelectBg-${projectId}`)
  }

  showThumbnailToast(type, id) {
    if(['hidden-task', 'show-task'].includes(type)) return;

    $('.thumbnail-project-pc').parent().find(`.project-thumb-${type}-label-toast-${id}`).addClass('zoom-hover')
  }

  hideThumbnailToast(type, id) {
    if(['hidden-task', 'show-task'].includes(type)) return;

    $('.thumbnail-project-pc').parent().find(`.project-thumb-${type}-label-toast-${id}`).removeClass('zoom-hover')
  }

  hiddenTaskForProject(projectId, projectName, event) {
    event.stopPropagation();
    const notShowPopup = $('#not_show_popup').val();
    $("#modalHiddenTask").find('#project_id').val(projectId)
    $("#modalHiddenTask").find('.project-name-text').text(projectName)
    $('.hidden-task-toast ').removeClass('zoom-hover')
    if(notShowPopup == 'true') {
      $("#modalHiddenTask").find('.btn-submit-setting-task-for-project').click();
    } else {
      $("#modalHiddenTask").find('#checkbox-show-popup-again').prop('checked', false);
      $("#modalHiddenTask").modal("show")
    }
  }

  showTaskForProject(projectId, projectName, event) {
    event.stopPropagation();
    const notShowPopup = $('#not_show_popup').val();
    $("#modalShowTask").find('#project_id').val(projectId)
    $("#modalShowTask").find('.project-name-text').text(projectName)
    $('.show-task-toast ').removeClass('zoom-hover')
    if(notShowPopup == 'true') {
      $("#modalShowTask").find('.btn-submit-setting-task-for-project').click();
    } else {
      $("#modalShowTask").find('#checkbox-show-popup-again').prop('checked', false);
      $("#modalShowTask").modal("show")
    }
  }

  submitHiddenTaskForProject(is_show_task, element, is_from_list_temp_file = 'false') {
    const project = this;
    const projectId = $(element).parent().find('#project_id').val()
    const notShowAgain = $(element).parent().find('#checkbox-show-popup-again').is(':checked')
    const url = Routes.hidden_task_for_project_owner_project_path(projectId)
    let buttonTextShowTask = $('table.table-project').length > 0 ?  '利用中' : 'タスク<span class="escape-text">利用中</span>'
    let buttonTextHiddenTask = $('table.table-project').length > 0 ?  '非表示' : 'タスク<span class="escape-text">非表示</span>'
    Shared.callAjax(url, { is_show_task: is_show_task, not_show_again: notShowAgain }, 'json', 'patch').done(function(data) {
      $('#modalAccessProjectFailed').modal('hide')
      if($('#modal-position-of-akaire-file').length > 0) {
        $('#modal-position-of-akaire-file').find('.setting-show-task').html(AkaireFile.contentSettingShowTaskInModalPositionOfFile(is_show_task, data.project_name, projectId))
        $('#modal-position-of-akaire-file').find('.btn-submit-change-position').removeClass('d-none')
      }
      if (is_show_task) {
        $("#modalShowTask").modal("hide")
        $(`.setting-task-for-project-${projectId}`).html(`
          <button
            class="btn btn-setting-task-for-project hidden-task font-weight-bold"
            onclick="Project.hiddenTaskForProject(${projectId}, '${data.project_name}', event)"
            onmouseover="Project.showThumbnailToast('hidden-task', ${projectId})"
            onmouseout="Project.hideThumbnailToast('hidden-task', ${projectId})"
          >
          ${buttonTextShowTask}
          </button>
        `)
        if (is_from_list_temp_file == 'true') {
          project.showListTaskFromListTempFile(projectId)
        }
        if($('table.table-project').length > 0) {
          $(`.setting-task-for-project-${projectId}`).parent().find('.add-task').removeClass('disabled')
          $(`.setting-task-for-project-${projectId}`).parent().find('.count-task').removeClass('disabled')
          $(`.setting-task-for-project-${projectId}`).closest('.project-list-task-count').attr('onclick', '')

        } else {
          $(`.setting-task-group-${projectId}`).attr('onclick', '')
          $(`.setting-task-group-${projectId}`).children().removeClass('disabled')
        }
        $(`.setting-task-for-project-humburger-${projectId}`).attr('data-is-show-task', 'true').text('タスクを非表示にする')
        $(`.setting-task-for-project-humburger-${projectId}`).parent().attr('href', Routes.owner_list_grantcharts_path(projectId))
        $(`.setting-task-for-project-humburger-${projectId}`).parent().attr('onclick', '')
      } else {
        $("#modalHiddenTask").modal("hide")
        $(`.setting-task-for-project-${projectId}`).html(`
          <button
            class="btn btn-setting-task-for-project show-task font-weight-bold"
            onclick="Project.showTaskForProject(${projectId}, '${data.project_name}', event)"
            onmouseover="Project.showThumbnailToast('show-task', ${projectId})"
            onmouseout="Project.hideThumbnailToast('show-task', ${projectId})"
          >
          ${buttonTextHiddenTask}
          </button>
        `)
        if($('table.table-project').length > 0) {
          $(`.setting-task-for-project-${projectId}`).parent().find('.add-task').addClass('disabled')
          $(`.setting-task-for-project-${projectId}`).parent().find('.count-task').addClass('disabled')
          $(`.setting-task-for-project-${projectId}`).closest('.project-list-task-count').attr('onclick', `Project.showModalTaskIsHidden(${projectId}, event)`)
        } else {
          $(`.setting-task-group-${projectId}`).attr('onclick', `Project.showModalTaskIsHidden(${projectId}, event)`)
          $(`.setting-task-group-${projectId}`).children().addClass('disabled')
        }
        $(`.setting-task-for-project-humburger-${projectId}`).attr('data-is-show-task', 'false').text('タスクを利用中にする')
        $(`.setting-task-for-project-humburger-${projectId}`).parent().attr('href', 'javascript:void(0)')
        $(`.setting-task-for-project-humburger-${projectId}`).parent().attr('onclick', `Project.showModalTaskIsHidden(${projectId}, event)`)
        if($('#modal-position-of-akaire-file').length > 0) {
          $('#modal-position-of-akaire-file').find('.task-setting').addClass('d-none')
          $('#modal-position-of-akaire-file').find('#task-id').val('')
          $('#modal-position-of-akaire-file').find('#type-change').val('project_change')
        }
      }
    })
  }

  showModalTaskIsHidden(projectId, event) {
    event.stopPropagation();
    window.location.href = Routes.akaire_file_project_akaire_file_index_path(projectId)
  }

  showPopupSettingTask(element) {
    const notShowAgain = $(element).is(':checked')
    const url = Routes.show_popup_setting_task_owner_projects_path()
    Shared.callAjax(url, { not_show_again: notShowAgain }, 'json', 'patch').done(function(data) {
      if (data.not_show_again == 'true') {
        $('#not_show_popup').val(data.not_show_again)
      } else {
        $('#not_show_popup').val('false')
      }
    })
  }

  settingTaskForProjectHumburger(projectId, projectName, event, element) {
    event.stopPropagation();
    let isShowTask = $(element).attr('data-is-show-task').toString()

    if (isShowTask == 'false') {
      this.showTaskForProject(projectId, projectName, event);
    } else {
      this.hiddenTaskForProject(projectId, projectName, event);
    }
  }

  showListTaskFromListTempFile(projectId) {
    $('.div-button-assign-file [data-from-project-id="' + projectId + '"]').attr('data-is-show-task', 'true')

    const savedTaskId = $('#assignAkairePopup').find('#saved-task-id').val()
    const url = Routes.fetch_list_task_akaire_feature_akaires_path({saved_project_id: projectId, saved_task_id: savedTaskId});
    Shared.callAjax(url, {saved_task_id: savedTaskId}, 'script', 'get').done(() => {
      $('#selectSavedTaskModal').modal('show')
      $('#assignAkairePopup').modal('hide')
    })
  }

  showNotiToastSP(ele, projectId, projectName, type, hide_popup_notify_project, event) {
    event?.stopPropagation()

    const notiEle = $(`.thumbnail-project-sp .project-thumb-noti-label-toast-${projectId}`)
    const isOpen = notiEle.hasClass('zoom-hover')

    $(document).off('click.notiToast')
    $('.thumb-sub-icons-group img').removeClass('click-zoom-in')

    if (isOpen) {
      notiEle.removeClass('zoom-hover')
      this.openPopupUpdateNotifyStatus(projectId, projectName, type, hide_popup_notify_project)
    } else {
      $('.thumbnail-project-sp .zoom-hover').removeClass('zoom-hover')
      notiEle.addClass('zoom-hover')
      $(ele).addClass('click-zoom-in')

      $(document).on('click.notiToast', (e) => {
        if (!$(e.target).closest(notiEle).length) {
          notiEle.removeClass('zoom-hover')
          $('.thumb-sub-icons-group img').removeClass('click-zoom-in')
          $(document).off('click.notiToast')
        }
      })
    }
  }

  showBackgroundToastSP(ele, projectId, perPage, event) {
    event?.stopPropagation()

    const bgEle = $(`.thumbnail-project-sp .project-thumb-background-label-toast-${projectId}`)
    const isOpen = bgEle.hasClass('zoom-hover')

    $(document).off('click.backgroundToast')
    $('.thumb-sub-icons-group img').removeClass('click-zoom-in')

    if (isOpen) {
      bgEle.removeClass('zoom-hover')
      this.clickBtnShowSelectBackground(projectId, perPage)
    } else {
      $('.thumbnail-project-sp .zoom-hover').removeClass('zoom-hover')
      bgEle.addClass('zoom-hover')
      $(ele).find('img').addClass('click-zoom-in')

      $(document).on('click.backgroundToast', (e) => {
        if (!$(e.target).closest(bgEle).length) {
          bgEle.removeClass('zoom-hover')
          $('.thumb-sub-icons-group img').removeClass('click-zoom-in')
          $(document).off('click.backgroundToast')
        }
      })
    }
  }


  showChatToastSP(ele, projectId, event) {
    const chatEle = $(`.thumbnail-project-sp .project-thumb-chat-label-toast-${projectId}`)
    const isOpen = chatEle.hasClass('zoom-hover')

    $(document).off('click.chatToast')
    $('.thumb-sub-icons-group img').removeClass('click-zoom-in')

    if (isOpen) {
      chatEle.removeClass('zoom-hover')
    } else {
      event?.preventDefault()
      event?.stopPropagation()

      $('.thumbnail-project-sp .zoom-hover').removeClass('zoom-hover')
      chatEle.addClass('zoom-hover')
      $(ele).find('img').addClass('click-zoom-in')

      $(document).on('click.chatToast', (e) => {
        if (!$(e.target).closest(chatEle).length) {
          chatEle.removeClass('zoom-hover')
          $('.thumb-sub-icons-group img').removeClass('click-zoom-in')
          $(document).off('click.chatToast')
        }
      })
    }
  }


  setNotiStateFromLabel(projectId, projectName, hide_popup_notify_project) {
    const notiState = $(`#status-${projectId} .reject-notify`).hasClass('d-none')
    this.openPopupUpdateNotifyStatus(projectId, projectName, notiState, hide_popup_notify_project)
  }

  openModalCreateTaskFromIcon(projectId, text_task_akaire, event) {
    event.preventDefault();
    const modalCreate = $("#createTaskProjectModalFromTwoOptions");
    const count_task = $(".project-list-thumb").is(":visible") ? $(`.thumb-project-task-num-${projectId}`).html() : $(`.current-count-task-${projectId}`).attr('data-count');

    modalCreate.attr('data-project-id', projectId)
    modalCreate.find(".btn-project-new.task").attr('href', Routes.owner_new_tasks_path(projectId))
    modalCreate.find("#taskName").val(`${text_task_akaire}${Number(count_task) + 1}`)
    if (modalCreate.find("#taskName").val().length > 0) {
      modalCreate.find('.submit-create').removeClass('disabled')
    }
    modalCreate.find('form').attr('action', Routes.create_from_project_list_owner_project_tasks_path(projectId))
    $(`#CreateTaskOptionsNewModal-${projectId}`).modal('hide')
    modalCreate.modal('show')
  }

  openModalCreateTaskFromTaskPage(projectId, text_task_akaire, countTask, event) {
    event.preventDefault();
    const modalCreate = $("#createTaskProjectModalFromTwoOptions");
    const taskCountChip = $('.akaire-file-count-chip__label').first();
    const currentCountFromChip = taskCountChip.length > 0 ? taskCountChip.text().match(/(\d+)/) : null;
    const currentCount = currentCountFromChip ? Number(currentCountFromChip[1]) : Number(countTask);
    const defaultTaskName = `${text_task_akaire}${currentCount + 1}`;

    modalCreate.attr('data-project-id', projectId);
    modalCreate.find("#taskName").val(defaultTaskName);
    modalCreate.find('form').attr('action', Routes.create_from_project_list_owner_project_tasks_path(projectId));

    if (defaultTaskName.length > 0) {
      modalCreate.find('.submit-create').removeClass('disabled');
    } else {
      modalCreate.find('.submit-create').addClass('disabled');
    }

    $('#CreateTaskOptionsTaskPageModal').modal('hide');
    modalCreate.modal('show');
  }
}

function deleteProject(projectId, deleteAtProjectsList) {
  const url = Routes.owner_project_path(projectId)
  Shared.callAjax(url, {}, 'json', 'delete').done(function(data) {
    Popup.confirm('', {
      description: '削除されました。',
      success: () => { handleReloadProjectsList(deleteAtProjectsList) },
      cancel: () => { handleReloadProjectsList(deleteAtProjectsList) },
      width: 'auto',
      confirmText: 'OK',
      cancelBtn: 'false'
    })
  })
  .fail(function(data) {
    Popup.alert(I18n.t('shared.one_error_please_try_again'))
  })
}

function handleReloadProjectsList(deleteAtProjectsList) {
  if (deleteAtProjectsList) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('check_data', `${gon.is_plan_akapon}`);
    window.location.search = urlParams;
  } else {
    window.location.href = Routes.owner_projects_path({check_data: `${gon.is_plan_akapon}`})
  }
}
